export interface Education {
  _key: string
  degree?: string
  institute?: string
}
export interface Employee {
  _id: string
  name: string
  avatar: EmployeeAvatar
  jobTitle: string
  categories: EmployeeCategory[]
  educations?: Education[]
  educationalDegree?: string
  description?: string
  employeeOrder?: EmployeeOrder[]
}
export interface EmployeeCategory {
  id: string
  category: string
}
export interface EmployeeAvatar {
  alt?: string
  srcKey: string
}
export interface EmployeeOrder {
  subCategory: string
  orderOfSubCategory?: string
  employeeOrderInSubCategory?: string
}

export interface EmployeeFields {
  employees: Employee[]
  categories: EmployeeCategory[]
}

export interface EmployeeFieldsError {
  employees: string
  categories: string
}

export interface EmployeeState {
  fields: EmployeeFields
  errors: EmployeeFieldsError
  backendError: string
}

export enum TABS {
  all = 'all',
  management = 'management',
  crew = 'crew',
  tutors = 'tutors',
  board = 'board',
}

export enum SUBCATEGORIES {
  management = 'Management',
  board = 'Board',
  marketing = 'Marketing',
  tech = 'Tech',
  gamification = 'Gamification',
  animation = 'Animation',
  design = 'Design',
  content = 'Content',
  recruitment = 'Recruitment',
  tutor = 'Tutor',
}
